// this file contains reusable variables of advance search 
// containsOptions used as dropdown list in advance search "contains text" tag
// dateRanges shows the time range options in "date range" tag
export const containsOptions = [
    {
      id: 'SHOULD',
      label: 'Should'
    },
    {
      id: 'MUST',
      label: 'Must'
    },
    {
      id: 'MUST_NOT',
      label: 'Must Not'
    }
  ];
  export const dateRanges = [
    {
      id: 0,
      label: 'All Time'
    },
    {
      id: 365,
      label: '1 Year'
    },
    {
      id: 180,
      label: '6 Months'
    },
    {
      id: 60,
      label: '2 Months'
    },
    {
      id: 30,
      label: '1 Month'
    },
    {
      id: 21,
      label: '3 Weeks'
    },
    {
      id: 7,
      label: '1 Week'
    },
    {
      id: 3,
      label: '3 Days'
    },
    {
      id: 1,
      label: '1 Day'
    }
  ];